<div class="footer-container">
    <div class="col1">
        <a class="accent" [routerLink]="['/impressum']">Impressum</a>
    </div>
    <div class="about-col2">
    </div> 
</div>